import React, { useState } from "react";
import DatePicker from "../../../components/UI/DatePicker/DatePicker";
import IntervalTimePicker from "../../../components/UI/IntervalTimePicker/IntervalTimePicker";

export const PASSWORD_TYPE_LABELS = {
  I: "رمز بارگذاری",
  O: "رمز برداشت",
  G: "رمز تخلیه",
  S: "رمز خاص",
};

export const PASSWORD_TYPES = ["I", "O", "G"];

const IntervalEditForm = ({
  startDate,
  startTime,
  endDate,
  endTime,
  passwordExpires,
  invalidDate,
  invalidTime,
  onStartDateChange,
  onStartTimeChange,
  onEndDateChange,
  onEndTimeChange,
  onPasswordExpireDateChange,
  onPasswordExpireTimeChange,
  headerText = "مقادیر جدید",
}) => {
  const [timeFocus, setTimeFocus] = useState({
    start: 0,
    end: 0,
    I: 0,
    O: 0,
    G: 0,
  });

  const focusTimeField = (key) => {
    setTimeFocus((prev) => ({
      ...prev,
      [key]: (prev[key] || 0) + 1,
    }));
  };

  return (
    <div className="change-interval-edit">
      <div className="change-interval-edit-title">{headerText}</div>

      <div className="change-interval-edit-columns">
        <section className="change-interval-block change-interval-block--reservation">
          <div className="change-interval-block-header">
            <span className="change-interval-block-badge">۱</span>
            <div>
              <h4 className="change-interval-block-title">بازه رزرو سفارش</h4>
              <p className="change-interval-block-desc">
                تاریخ و ساعت شروع و پایان رزرو را مشخص کنید
              </p>
            </div>
          </div>

          <div className="change-interval-fields">
            <div className="row change-interval-field-row">
              <DatePicker
                className={
                  invalidDate && (startDate == null || startDate == "")
                    ? "invalid-date"
                    : ""
                }
                change={(unix, formatted) => {
                  onStartDateChange(unix, formatted);
                  focusTimeField("start");
                }}
                value={startDate}
                placeHolder="تاریخ شروع رزرو"
                col="8"
              />
              <IntervalTimePicker
                onChange={onStartTimeChange}
                value={startTime}
                placeHolder="ساعت شروع"
                focusTrigger={timeFocus.start}
                className={
                  invalidTime &&
                  (startTime == null || startTime == "" || startTime == "0:0")
                    ? "invalid-time"
                    : ""
                }
                col="4"
              />
            </div>

            <div className="row change-interval-field-row">
              <DatePicker
                className={
                  invalidDate && (endDate == null || endDate == "")
                    ? "invalid-date"
                    : ""
                }
                change={(unix, formatted) => {
                  onEndDateChange(unix, formatted);
                  focusTimeField("end");
                }}
                value={endDate}
                placeHolder="تاریخ پایان رزرو"
                col="8"
              />
              <IntervalTimePicker
                onChange={onEndTimeChange}
                value={endTime}
                placeHolder="ساعت پایان"
                focusTrigger={timeFocus.end}
                className={
                  invalidTime &&
                  (endTime == null || endTime == "" || endTime == "0:0")
                    ? "invalid-time"
                    : ""
                }
                col="4"
              />
            </div>
          </div>
        </section>

        <section className="change-interval-block change-interval-block--passwords">
          <div className="change-interval-block-header">
            <span className="change-interval-block-badge">۲</span>
            <div>
              <h4 className="change-interval-block-title">انقضای رمزها</h4>
              <p className="change-interval-block-desc">
                در صورت نیاز، تاریخ و ساعت انقضای هر رمز را تنظیم کنید
              </p>
            </div>
          </div>

          <div className="change-interval-password-list">
            {PASSWORD_TYPES.map((type) => (
              <div className="change-interval-password-item" key={type}>
                <div className="change-interval-password-item-label">
                  {PASSWORD_TYPE_LABELS[type]}
                </div>
                <div className="row change-interval-field-row">
                  <DatePicker
                    change={(unix, formatted) => {
                      onPasswordExpireDateChange(type, formatted);
                      focusTimeField(type);
                    }}
                    value={passwordExpires[type]?.expireDate || ""}
                    placeHolder="تاریخ انقضا"
                    col="8"
                  />
                  <IntervalTimePicker
                    onChange={(value) =>
                      onPasswordExpireTimeChange(type, value)
                    }
                    value={passwordExpires[type]?.expireTime || ""}
                    placeHolder="ساعت انقضا"
                    focusTrigger={timeFocus[type]}
                    col="4"
                  />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default IntervalEditForm;
